module.exports = __webpack_public_path__ + "static/img/310.f4e43fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/2019-07-24/310.png
// module id = b3cC
// module chunks = 6